import { module } from 'modujs';
import { gsap } from 'gsap';
import { SplitText } from "../libs/gsap/SplitText";

gsap.registerPlugin(SplitText);

export default class extends module {
    constructor(m) {
        super(m);

		this.events = {
			mouseenter: {
				wrap: 'hover'
			}
		}

		this.auto = typeof this.getData('auto') == 'string';

		this.delay = typeof this.getData('delay') == 'string' ? parseFloat(this.getData('delay')) : 0;
		this.stagger = typeof this.getData('stagger') == 'string' ? parseFloat(this.getData('stagger')) : 0.3;
		this.duration = typeof this.getData('duration') == 'string' ? parseFloat(this.getData('duration')) : 0.8;
    }

    init() {
		if(window.isAndroid) return;

		this.split = new SplitText(this.el, {
			type: 'chars, lines'
		});

		this.hide(0,0);
    }

	ready() {
		if(window.isAndroid) return;

		if(this.auto) {
			this.display(this.delay, this.duration, this.stagger);
		}
	}

	toggle(e) {
		if(window.isAndroid) return;

		if(e.mode == 'enter') {
			this.display(this.delay, this.duration, this.stagger);
		} else {
			this.hide();
		}
	}

	display(delay, duration, stagger) {
		if(window.isAndroid) return;

		if(this.tl != undefined) {
			this.tl.kill();
		}
		this.tl = gsap.timeline();

		this.tl.to(this.split.chars, {
			y: 0,
			duration: duration,
			delay,
			ease: "power2.out",
			stagger: {
				amount: stagger,
				from: 'center'
			}
		});
		
	}

	hide(delay = 0, duration = 0.5) {
		if(window.isAndroid) return;

		if(this.tl != undefined) {
			this.tl.kill();
		}
		this.tl = gsap.timeline();

		this.tl.to(this.split.chars, {
			y: '105%',
			duration,
			delay,
			ease: "power2.in",
			stagger: {
				amount: 0.1,
				from: 'center'
			}
		});
	}

}
